// src/shared/auth/isVisitorUser.ts
// Treat public_viewer/visitor identities as anonymous public sessions,
// not as authenticated app-shell users.

export function isVisitorUser(user: any | null | undefined): boolean {
  if (!user || typeof user !== 'object') return false

  const name = String(user?.name ?? '').toLowerCase()
  const email = String(user?.email ?? '').toLowerCase()
  const userType = String(user?.type ?? user?.user_type ?? '').toLowerCase()
  const role = String(user?.role ?? '').toLowerCase()

  const rolesRaw = user?.roles
  const roles = Array.isArray(rolesRaw)
    ? rolesRaw.map((r: unknown) => String(r).toLowerCase())
    : []

  return (
    name.startsWith('visitor-') ||
    email.includes('visitor') ||
    userType === 'visitor' ||
    role === 'public_viewer' ||
    roles.includes('public_viewer')
  )
}
